// Cliente HTTP
import { AxiosInstance, HttpClient } from '@pjn/ajax/HttpClient';

// Seguridad
import { securityProvider } from './securityProvider';

// APIs
import * as StaticApi from './StaticApi';
import { MagistradoRestApi } from './MagistradoApi';
import { ExpedienteRestApi } from './ExpedienteApi';
import { DenunciaRestApi } from './DenunciaApi';
import { ConfiguracionRestApi } from './ConfiguracionApi';
import { AlertaRestApi } from './AlertaApi';





/**
 * Cliente HTTP que usan todas las clases API.
 * Se configura la URL Base, la seguridad (opcional) y otras configuraciones de Axios.
 * Ademas se puede opcionalmente configurar un Delay en desarrollo para simular latencia.
 */
const http: AxiosInstance = HttpClient.create({
  identityProvider: securityProvider, // <- Agrega header de Auth y maneja errores de seguridad
  headers: {
    'Access-Control-Allow-Origin': '*'
  },
  withCredentials: true,
  
});


// Se crean y exportan los singleton de API para poder importarlos en donde sea necesario.
export const staticApi = StaticApi;

export const magistradoApi = new MagistradoRestApi(http);
export const expedienteApi = new ExpedienteRestApi(http);
export const denunciaApi = new DenunciaRestApi(http);
export const configuracionApi = new ConfiguracionRestApi(http);
export const alertaApi = new AlertaRestApi(http);

